import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./ItemListContainer.css";
import { Spinner, Flex } from "@chakra-ui/react";
import { ItemList } from "../ItemList/ItemList";
import { getProducts, getProductsByCategory } from "../../data/asyncMock";
import { collection, docs, getDocs, query, where } from "firebase/firestore";
import { db } from "../../utils/config";
export const ItemListContainer = ({ greeting }) => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { categoryId } = useParams();

  // const categorias = [{id:1,descripcion:"T-shirts"},{id:2,descripcion:"Shirts"}, {id:2,descripcion:"Blouses"}]

  // useEffect es un gancho de React que permite realizar efectos secundarios en componentes funcionales
  // Se ejecutará cada vez que cambie la dependencia [categoryId]
  useEffect(() => {
    // getData es una función asincrónica que obtiene datos según la categoría o todos los productos si no hay una categoría especificada
    const getData = async () => {
      // Vamos a crear una referencia que a nuestra colección "products" de Firebase
      // Si categoryId es falso (falsy), se obtienen todos los productos
      // De lo contrario, se obtienen productos filtrados por la categoría específica
      const queryRef = !categoryId
        ? collection(db, "products")
        : //Esto crea una consulta que combina la referencia a la colección con una o más cláusulas de filtrado.
          // En este caso, solo hay una cláusula de filtrado que se aplica si categoryId está presente.
          query(
            collection(db, "products"),
            // cláusula de filtrado. Indica que solo se deben devolver los documentos donde la propiedad "category" sea igual al valor de categoryId.
            where("category", "==", categoryId)
          );

      // Se realiza la consulta a la base de datos Firestore y se espera la respuesta
      const response = await getDocs(queryRef);

      // Se mapean los documentos de la respuesta para extraer los datos y asignar un nuevo ID a cada producto
      const products = response.docs.map((doc) => {
        const newProduct = {
          ...doc.data(), // Se copian los datos del documento
          id: doc.id, // Se asigna el ID del documento como propiedad 'id'
        };
        return newProduct;
      });

      // Se establece un temporizador de 1000 milisegundos (1 segundo) antes de actualizar el estado
      setTimeout(() => {
        // Se actualiza el estado 'productos' con la lista de productos obtenidos
        setProductos(products);
        // Se actualiza el estado 'loading' a 'false' para indicar que la carga ha finalizado
        setLoading(false);
      }, 1000);
    };

    // Se llama a la función getData al montar el componente o cuando cambia categoryId
    getData();
  }, [categoryId]);

  return loading ? (
    <Flex align="center" justify="center">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
        mt="5rem"
      />
    </Flex>
  ) : (
    <section className="products">
      <h1 className="titulo">{greeting}</h1>

      <ItemList productos={productos} />
    </section>
  );
};
